import type { DerivedRegistrationStatus, Fase, RegistrationCancelHistoryEntry } from './inscritosVocabulary';
import { cancelReasonLabel, formatRegistryDate, statusLabel, statusToneClassName } from './inscritosVocabulary';

export interface InscritoStatusBadgeProps {
  derivedStatus: DerivedRegistrationStatus;
  fase: Fase;
  /**
   * O cancelamento mais recente da linha (`latestCancellation`, em
   * `inscritosVocabulary.ts`) — `undefined` numa linha nunca cancelada, e
   * também numa linha cancelada sem nenhum dado de cancelamento (spec.md, "A
   * linha cancelada mostra por que foi cancelada": a tela nunca infere um
   * motivo a partir da situação). Ausente, o selo é desenhado sozinho, sem
   * reservar espaço para motivo, instante ou observação.
   */
  cancellation?: RegistrationCancelHistoryEntry;
}

export function InscritoStatusBadge({ derivedStatus, fase, cancellation }: InscritoStatusBadgeProps) {
  const badge = (
    <span className={`rounded-chip px-2 py-0.5 text-xs font-medium ${statusToneClassName(derivedStatus, fase)}`}>
      {statusLabel(derivedStatus, fase)}
    </span>
  );

  if (!cancellation) return badge;

  const reasonLabel = cancelReasonLabel(cancellation.cancelReason);
  const instant = formatRegistryDate(cancellation.canceledAt);

  return (
    <div className="flex min-w-0 flex-col items-start gap-1">
      {badge}
      {/* `w-full`: sem ele, `items-start` encolheria este bloco para o
          tamanho do próprio texto, e o `truncate` abaixo não teria o que
          cortar — a coluna, não o conteúdo, tem de decidir a largura. */}
      <div className="flex min-w-0 w-full flex-col">
        <span className="truncate text-[12px] text-ink-muted" title={reasonLabel}>
          {reasonLabel}
        </span>
        <span className="truncate text-[12px] text-ink-muted" title={instant}>
          {instant}
        </span>
        {cancellation.cancelNote && (
          <span className="truncate text-[12px] text-ink-muted" title={cancellation.cancelNote}>
            {cancellation.cancelNote}
          </span>
        )}
      </div>
    </div>
  );
}
